export var addDays = function (d, daysCount) {
    var newDate = new Date(d);
    newDate.setDate(newDate.getDate() + daysCount);
    return newDate;
};
export var todaysDate = function () {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
};
export var endOfDayDate = function (d) {
    var newDate = new Date(d);
    newDate.setHours(23, 59, 59, 999);
    return newDate;
};
export var isInRange = function (range, dateToCheck) {
    var _a, _b;
    if (Array.isArray(range) && range.length === 2) {
        var start = (_a = range[0]) === null || _a === void 0 ? void 0 : _a.getTime();
        var end = (_b = range[1]) === null || _b === void 0 ? void 0 : _b.getTime();
        if (!start || !end)
            return false;
        return ((start < dateToCheck.getTime() && end > dateToCheck.getTime()) ||
            start === dateToCheck.getTime() ||
            end === dateToCheck.getTime());
    }
    return false;
};
export var isStartOfRange = function (range, dateToCheck) {
    var _a;
    if (Array.isArray(range) && range.length >= 1) {
        var start = (_a = range[0]) === null || _a === void 0 ? void 0 : _a.getTime();
        return start === dateToCheck.getTime();
    }
    return false;
};
export var isEndOfRange = function (range, dateToCheck) {
    var _a;
    if (Array.isArray(range) && range.length === 2) {
        var end = (_a = range[1]) === null || _a === void 0 ? void 0 : _a.getTime();
        return end === dateToCheck.getTime();
    }
    return false;
};
var DATE_REGEX = /^(0?[1-9]|1[012])[/](0?[1-9]|[12][0-9]|3[01])[/]\d{4}$/;
export var isValidDateStr = function (dateStr) {
    if (dateStr) {
        return !!dateStr.match(DATE_REGEX);
    }
    return false;
};
export var isValidDate = function (date) {
    return !!date && !isNaN(date.getTime());
};
export var invalidDate = function () {
    return new Date('/');
};
export var isInHighlightedRange = function (highlightedDates, dateToCheck) {
    return highlightedDates.some(function (range) { return isInRange(range, dateToCheck); });
};
//# sourceMappingURL=dateHelpers.js.map